import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import AffiliateTracker from './components/AffiliateTracker';
import SurveyGate from './components/SurveyGate.js';
import AccountStatusModal from './components/AccountStatusModal';
import tracker from './utils/tracker';

import AOS from 'aos';
import 'aos/dist/aos.css';

import Home from './pages/Home/Home';
import Purchase from './pages/AppBar/PurchasePage';
import Guide from './pages/AppBar/Guide';
import Login from './pages/Auth/Login';
import SignUp from './pages/Auth/SignUp';
import Affiliate from './pages/AppBar/AffiliatePage';
import Privacy from './pages/Other/Privacy';
import Terms from './pages/Other/Terms';
import Payment from './pages/Payment/Payment';
import Success from './pages/Payment/Success';
import ScrollToTop from './components/ScrollToTop';
import Cancel from './pages/Payment/Cancel';
import Dashboard from './pages/Dashboard/Dashboard';
import AffiliateDash from './pages/Dashboard/AffiliateDash';
import SettingsDash from './pages/Dashboard/SettingsDash';
import AffiliateGuide from './pages/Other/AffiliateGuide';
import WithdrawEarnings from './pages/Dashboard/WithdrawEarnings';
import WalletsDash from './pages/Dashboard/WalletsDash';
import WithdrawDash from './pages/Dashboard/WithdrawDash';
import AdminPanel from './pages/Other/Admin/AdminPanel';
import ForgotPassword from './pages/Auth/ForgotPassword';

// Sits inside BrowserRouter. Fires a page_view on every route change —
// for anonymous visitors too (the tracker handles identity via cookies).
// The tracker itself is a module singleton, so StrictMode double-mounts
// and the doubled AuthProvider are harmless.

const ActivityTracker = () => {
  const location = useLocation();

  useEffect(() => {
    tracker.trackPageView(location.pathname);
  }, [location.pathname]);

  return null;
};

function App() {
  useEffect(() => {
    setTimeout(() => {
      AOS.init({
        once: true,
        mirror: false,
        startEvent: 'DOMContentLoaded',
        delay: 65,
      });
      AOS.refresh();
    }, 60);
  }, []);

  return (
    <BrowserRouter>
      <AffiliateTracker />
      <AuthProvider>
        <ActivityTracker />
        <AccountStatusModal />
        <SurveyGate />
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/purchase" element={<Purchase />} />
          <Route path="/affiliate" element={<Affiliate />} />
          <Route path="/guide" element={<Guide />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/subscribe" element={<Payment />} />
          <Route path="/success" element={<Success />} />
          <Route path="/cancel" element={<Cancel />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/affiliateDash" element={<AffiliateDash/>} />
          <Route path="/settings" element={<SettingsDash />} />
          <Route path="/affiliateGuide" element={<AffiliateGuide />} />
          <Route path="/wallets" element={<WalletsDash />} />
          <Route path="/withdraw" element={<WithdrawDash />} />
          <Route path="/withdraw-earnings" element={<WithdrawEarnings />} />
          <Route path="/adminPanel" element={<AdminPanel />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;

// git add .
// git commit -m "frontend update"
// git push